const storeLocatorData = [
    {
        img:'https://i.ibb.co/kh89TTL/Aesop-HK-K11-Hero-Bleed-Desktop-2880x1620px.jpg'
    },
    {
        img:'https://i.ibb.co/C730wNW/Aesop-HK-New-Town-Plaza-Hero-Bleed-Desktop-2880x1620px.jpg'
    },
    {
        img:'https://i.ibb.co/Tgw7Mx0/Aesop-HK-Hollywood-Road-Hero-Desktop-2880x1620.jpg'
    },
]

export default storeLocatorData;